import styled from 'styled-components'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from 'semantic-ui-react'
import { LoginPopups, LoginPopupsService } from '~/api/services/loginPopups'
import Dialog from '~/components/Dialog'
import { useAuth } from '~/routes/components/AuthProvider'
import { handleErrors } from '~/utils/helpers'
import { El } from '../style'
import InfoLoginPopup from './InfoLoginPopup'
import ChangeDataPopup from './ChangeDataPopup'

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  max-width: 80%;
`;

const StyledMessage = styled(Message)`
 .header {
  padding: 0 !important;
 }
`
export const CHANGE_FORM_ID = 'change-form-id'

const LoginPopup:React.FC = () => {
  const { t } = useTranslation()
  const { setSystemData, systemData, systemData: { logged: { popUpsOnLogin }, openedLoginPopups } } = useAuth()
  const loginPopupRef = useRef<HTMLHeadingElement>(null)
  
  const [isLoginPopupDisabled, setIsLoginPopupDisabled] = useState(popUpsOnLogin)
  const [statePopupsLogin, setStateTrackPopusLogin] = useState(openedLoginPopups)
  const [loginPopups, setLoginPopups] = useState<LoginPopups>({
    changeDataPopUps: [],
    infoPopUps: []
  })
  const [loadingPopups, setLoadingPopups] = useState(false)

  const [isBusy, setIsBusy] = useState(false)
  const [canSubmit, setCanSubmit] = useState(true)
  const [activePopupId, setActivePopupId] = useState<string>()

  useEffect(() => {
    fetchLoginPopups()
  }, [statePopupsLogin])

  async function fetchLoginPopups() {
    setLoadingPopups(true)
    try {
      const response = await LoginPopupsService.getFarmerLoginPopups()
      setLoginPopups(response.data)
    } catch (error) {
      // do nothing
    }
    setLoadingPopups(false)
  }

  async function handleEnableDisableLoginPopups() {
    setIsBusy(false)
    try {
      if (isLoginPopupDisabled === 0) {
        await LoginPopupsService.disableLoginPopups()
      } else {
        await LoginPopupsService.enableLoginPopups()
      }
      setSystemData({
        ...systemData,
        logged: {
          ...systemData.logged,
          popUpsOnLogin: isLoginPopupDisabled ? 0 : 1
        },
        openedLoginPopups: true
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderInfoPopups() {
    return <StyledContainer>
      <InfoLoginPopup
        items={loginPopups.infoPopUps}
        headerRef={loginPopupRef}
      />
    </StyledContainer>
  }

  function renderChangeDataPopup() {
    return <div>
      <ChangeDataPopup
        items={loginPopups.changeDataPopUps}
        handleConfirmLastData={() => fetchLoginPopups()}
        headerRef={loginPopupRef}
        onCanSubmitChange={setCanSubmit}
        onActivePopupChange={setActivePopupId}
      />
    </div>
  }

  function renderNoResults() {
    return <StyledMessage info style={{ margin: '20px auto', maxHeight: 70 }}>
      <Message.Header style={{ padding: 0 }}>{t('No results')}</Message.Header>
      <p>{t('Sorry, there are no login popups to display.')}</p>
    </StyledMessage>
  }

  async function handleCloseChangeData() {
    if (!activePopupId) return
    try {
      await LoginPopupsService.closeChangeDataPopup(activePopupId)
    } catch (error) {
      // do nothing
    }
  }

  if(loginPopups?.changeDataPopUps?.length > 0) {
    return <Dialog
      open={!statePopupsLogin}
      width='80%'
      textContent={!loadingPopups ? renderChangeDataPopup() : renderNoResults()}
      htmlContent
      textSubmit={t('Submit')}
      textClose={t('Close')}
      minHeight={'calc(90vh - 10em)'}
      styleContent={{ background: 'rgb(244, 246, 248)' }}
      typeButton='submit'
      formId={CHANGE_FORM_ID}
      disableSubmit={!canSubmit}
      isLoading={isBusy || loadingPopups}
      textHeader={<h2 ref={loginPopupRef}>{''}</h2>}
      handleClose={() => {
        setSystemData({ ...systemData, openedLoginPopups: true })
        handleCloseChangeData()
      }}
    />
  }

  return <Dialog
    open={!statePopupsLogin && loginPopups.infoPopUps.length > 0}
    textContent={<>
      {loginPopups.infoPopUps.length > 0 && !loadingPopups ? renderInfoPopups() : renderNoResults()}
      <El.StyledCheckbox
        label={t('Do not show again')}
        checked={isLoginPopupDisabled === 0}
        onChange={(e, data) => setIsLoginPopupDisabled(data.checked ? 0 : 1)}
        />
    </>}
    htmlContent
    textClose={t('Close')}
    width='70%'
    isLoading={isBusy || loadingPopups}
    textHeader={<h2 ref={loginPopupRef}>{''}</h2>}
    handleClose={() => {
      if (isLoginPopupDisabled !== systemData?.logged.popUpsOnLogin) {
        handleEnableDisableLoginPopups()
      } else {
        setSystemData({ ...systemData, openedLoginPopups: true })
      }
    }}
    />
}
export default LoginPopup